export default "__VITE_ASSET__60ac4c5e__"